import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { SiteShell } from "@/project/components/site-shell";
import { galleryItems, initiatives } from "@/project/data/sample";

export const Route = createFileRoute("/gallery")({
  head: () => ({
    meta: [
      { title: "Gallery — Daan Amrut Foundation" },
      { name: "description", content: "Photographs from Daan Amrut Foundation's programmes across seven initiatives." },
      { property: "og:title", content: "Gallery — Daan Amrut Foundation" },
      { property: "og:description", content: "Real moments from the ground — animals, children, kitchens, camps and more." },
    ],
  }),
  component: Page,
});

function Page() {
  const tags = ["All", ...Array.from(new Set(galleryItems.map((g) => g.tag)))];
  const [active, setActive] = useState("All");
  const items = active === "All" ? galleryItems : galleryItems.filter((g) => g.tag === active);
  return (
    <SiteShell>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[var(--saffron-deep)]">Gallery</p>
        <h1 className="mt-2 font-display text-4xl font-semibold text-[var(--maroon-deep)] sm:text-5xl">Real moments, real seva</h1>
        <p className="mt-3 max-w-2xl text-foreground/70">Photographs from the field — cows, children, kitchens, camps and every rescue in between.</p>
        <div className="mt-8 flex flex-wrap gap-2">
          {tags.map((t) => (
            <button key={t} onClick={() => setActive(t)}
                    className={`rounded-full border px-4 py-1.5 text-xs font-medium transition ${active === t ? "border-[var(--maroon)] bg-[var(--maroon)] text-[var(--cream)]" : "border-border bg-white text-foreground/70 hover:border-[var(--maroon)]/40"}`}>
              {t}
            </button>
          ))}
        </div>
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((g, idx) => (
            <figure key={idx} className="group overflow-hidden rounded-2xl border border-border/60 bg-card shadow-[var(--shadow-soft)]">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={g.image} alt={g.caption} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <span className="absolute left-3 top-3 rounded-full bg-white/95 px-3 py-1 text-[10px] font-semibold uppercase tracking-wider text-[var(--maroon-deep)]">{g.tag}</span>
              </div>
              <figcaption className="p-4 text-sm text-foreground/75">{g.caption}</figcaption>
            </figure>
          ))}
        </div>
        <p className="mt-10 text-center text-xs text-foreground/70">Featuring work across {initiatives.length} initiatives.</p>
      </section>
    </SiteShell>
  );
}